import { CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';

export const developmentGuard: CanActivateFn = () => {
    return !environment.production;
};
